import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { StudentProfile } from '../../../AllAPI/StudentAPI'

const AllotedRoomBedDetails = () => {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)

  const formDataFromStorage = JSON.parse(
    sessionStorage.getItem('studentData') || '{}',
  )
  const RegId = formDataFromStorage.reg_id
  const BoardingYear = formDataFromStorage.year

  // Format date ⇒ dd/mm/yyyy
  const formatDate = (dateString) => {
    if (!dateString) return '-'
    const d = new Date(dateString)
    return d.toLocaleDateString('en-GB') // dd/mm/yyyy
  }

  useEffect(() => {
    fetchProfile()
  }, [])

  const fetchProfile = async () => {
    try {
      const res = await axios.get(`${StudentProfile}/${RegId}/${BoardingYear}`)
      setData(res.data)
    } catch (err) {
      console.log('Error:', err)
    }
    setLoading(false)
  }

  if (loading) return <h4 className="text-center mt-5">Loading...</h4>
  if (!data) return <h4 className="text-center mt-5">No Profile Found</h4>

  const room = data.roombooking || {}

  return (
    <div className="form-container mainContainer">
      <div className="row p-0 m-0 pb-5">
        <div className="col-12 col-md-2"></div>
        <div className="col-12 col-md-8">
          <div className="header-row">
            <h2 className="page-title">Room-Bed Details</h2>
          </div>

          {/* ========================= ROOM & BED ALLOCATION ============================= */}
          <div className="card shadow-sm p-4 mb-4">
            {room ? (
              <div className="row">
                <div className="col-md-3">
                  <span style={{ fontWeight: '600' }}>Building Name:</span>
                  <p
                    className="shadow py-3 px-3 rounded"
                    style={{ backgroundColor: '#f0daab' }}
                  >
                    {room.class?.class_name}
                  </p>
                </div>

                <div className="col-md-3">
                  <span style={{ fontWeight: '600' }}>Room No:</span>
                  <p
                    className="shadow py-3 px-3 rounded"
                    style={{ backgroundColor: '#dee9fc' }}
                  >
                    {room.room?.room_no}
                  </p>
                </div>

                <div className="col-md-3">
                  <span style={{ fontWeight: '600' }}>Bed No:</span>
                  <p
                    className="shadow py-3 px-3 rounded"
                    style={{ backgroundColor: '#d6fce3' }}
                  >
                    {room.bed?.bed_no}
                  </p>
                </div>

                <div className="col-md-3">
                  <span style={{ fontWeight: '600' }}>Allocated On:</span>
                  <p
                    className="shadow py-3 px-3 rounded"
                    style={{ backgroundColor: '#fddcc4' }}
                  >
                    {formatDate(room.createdAt)}
                  </p>
                </div>
              </div>
            ) : (
              <p>No Room Allocated</p>
            )}
          </div>
        </div>
        <div className="col-12 col-md-2"></div>
      </div>
    </div>
  )
}

export default AllotedRoomBedDetails
